import { IUser } from 'types/user';

export const fetchUser = async () => {
  const response = await fetch('/api/session/get');
  return (await response.json()) as IUser;
};
